<template>
	<section>
		<bread-crumb></bread-crumb>
        <div class="wrap">
            <div class="title-wrap">
                <div>
                    <span v-for='(item,index) in tabs' :key="index" :class="newsFlag == index?'current':''" @click='changeNews(index,item)'>{{item.name}}</span>
                </div>
                <div class="edit" @click='isMgShow=!isMgShow'>编辑</div>
            </div>
            
            <ul class="news-wrap">
                <li v-for='(item,index) in newsList' :key="index" @click="toDetail(item)">
                    <span>{{item.title}}</span>
                    <div>
                        <span>{{item.create_time}}</span>
                        <img src="../../assets/img/delete.png" v-if='isMgShow' @click="deleteNews(item)">
                    </div>
                </li>
            </ul>
        </div>
        
        <common-modal v-if="isShowTips" :is-show-close="isShowClose" @close="isShowTips = false">
        	<div class="agree-wrap">
        		<div class="agree-text">	
        			<p v-html='newDetail'></p>
        		</div>
        	</div>
        </common-modal>
	</section>
</template>

<script>
import BreadCrumb from '@/components/BreadCrumb.vue';	
import CommonModal from '@/components/commonModal.vue';
import {getUserMessage,getMessageDetail,deleteUserMessage} from '@/api/personal'
export default {
    data() {
    	return {
            newsFlag:0,
            isMgShow:false,
            tabs:[
                {name:"通知公告",type:"1"},
                {name:"系统消息",type:"2"}
            ],
			body: {
				page_index: 1,
				page_size: 10
			},
			type:"1",
			newsList:[],
            newDetail:"",
            isShowClose:true,
            isShowTips:false
		};
    },
	
	created(){
		this.getUserMessage(this.type);
	},
  
    methods:{
        async getUserMessage(type){
        	let obj={type:type,page_index:this.body.page_index,page_size:this.body.page_size};
            const { data, status } = await getUserMessage(obj);
            if (status !== 200) return 
        	this.newsList = data.data;
        },
		
		changeNews(index,item){
			this.newsFlag = index;
			this.body.page_index = 1;
			this.newsList =[];
			this.isMgShow = false;
            this.type = item.type;
			this.getUserMessage(item.type)
		},
        
        async deleteNews(item){
            const { data, status } = await deleteUserMessage(item.uuid);
            if (status == 200) {
                if(data == "1"){
                    this.$message.success("消息删除成功")
                    this.getUserMessage(this.type);
                }else{
                    this.$message.error("系统繁忙，请稍后再试")
                }
            }
        },
        
        toDetail(item) {
            if(item.order_uuid){
                this.$router.push({
                	path: './order-detail',
                	query: {
                		order_uuid: item.order_uuid
                	}
                });
            }
            else{
                this.newDetail = item.content
                this.isShowTips = true;
            }
        }
    },
	
	components: {
	    BreadCrumb,
        CommonModal
	}
};
</script>

<style lang="scss" scoped>
    .wrap{
        padding: 0 30px 213px 30px;
        margin-top: 30px;
        background: #FFFFFF;
        .title-wrap{
            padding: 30px 26px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 1px solid #DFEDFF;
            span{
               @include font-style;
               font-size: 20px;
               color: #666666;
               margin-right: 56px;
               cursor: pointer;
            }
            .current{
                font-size: 20px;
                font-weight: bold;
                color: #FF8D1C;
            }
            span:last-child{
                margin-right: 0;
            }
            .edit{
                @include font-style;
                cursor: pointer;
                padding-left: 26px;
                font-size: 16px;
                color: #676565;
                background: url(../../assets/img/edit.png) no-repeat left center;
                background-size: 16px;
            }
         
        } 
        .news-wrap{
            li{
                @include cursor-style;
                padding: 20px 26px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #DFEDFF;
                img{
                    width: 14px;
                    height: 14px;
                    margin-left: 30px;
                    cursor: pointer;
                }
            }
        }
    }
    
    .agree-wrap{
        h1{
            border-bottom: 0.026667rem solid #E9E9E9;
            padding: 15px;
            text-align:center;
            @include font-style;
            font-size: 20px;
            color: #000000;
        }
        .agree-text{
            box-sizing: border-box;
            padding: 40px;
            background: #FFFFFF;
            line-height:30px;
            letter-spacing: 2px;
            p{
                margin-bottom: 20px;
            }
            p:last-child{
                margin-bottom: 0;
            }
        }
    }
</style>